import React from 'react';
import './style.scss'
import { Link, matchPath } from "react-router-dom";
import { Translation } from "react-i18next";
import i18n from "../../../i18n";
import { asset } from "../../../helpers/dom.helper";
import {isMobile} from 'react-device-detect';

class HeaderForBoard extends React.PureComponent {

  getIsMatch(pattern) {
    const path = this.props.match?.url
    return !!matchPath(path, { path: pattern })
  }

  render() {
    return (
      <Translation ns={['translation', 'forBoard']}>
        {(t) => (
          <div className="header-for-board" style={{
            '--forboard-bg-header': `url(${asset('/images/background/forBoard.webp')})`
          }}>
            <div className="container">
              <div className="row">
                <div className="col-12">

                  <div className="subMenu">
                    <Link to={(i18n.language !== "th" ? "/" + i18n.language : "") + "/for-board"}
                      className={this.getIsMatch("/:lang?/for-board") ? "active" : ""}>
                      {t("forResident:Committee")}
                    </Link>
                    <Link to={(i18n.language !== "th" ? "/" + i18n.language : "") + "/for-resident"}
                      className={this.getIsMatch("/:lang?/for-resident") ? "active" : ""}>
                      {t("forResident:Resident")}
                    </Link>
                  </div>

                  <div className="cover">
                    <h1 dangerouslySetInnerHTML={{ __html: t("forBoard:SILVERMAN...The system that committees can trust") }} />
                    {
                      !isMobile &&
                      <h2 dangerouslySetInnerHTML={{
                        __html: t("forBoard:Our reliable platform will simply boosts committees' " +
                          "credibility and build trust with residents.")
                      }} />
                    }
                    <Link to={(i18n.language !== "th" ? "/" + i18n.language : "") + "/register"}>
                      <button className="btn btn-light mt-4">
                        {t("forBoard:Try it free")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

}

export default HeaderForBoard;
